// this file will contain all the actions related to spo
//  first focus on create and then update

import { TOAST_TYPE } from '@base'
import { poStatus } from '@constants'
import { getAllBrandApi, getAllOrgSuppliersApi } from '@data'
import API from '@data/conn/api'
import convertPagableData from '@data/conn/convertPagableData'
import getUrl from '@data/conn/get/paths'
import { createSupplierOrder } from '@data/conn/post/SupplyOrder'
import { updateSpoApi } from '@data/conn/put/SupplyOrder'
import { showLoader, showToast } from '@data/state/action'
import { paths } from '@routes'

export const CREATE_NEW_SPO = 'CREATE_NEW_SPO'
export const CREATE_SPO_FROM_DATA = 'CREATE_SPO_FROM_DATA'
export const CLEAR_SPO_STATE = 'CLEAR_SPO_STATE'

export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS'
export const FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE'
export const FETCH_CATEGORIES_PROGRESS = 'FETCH_CATEGORIES_PROGRESS'

export const FETCH_BRANDS_SUCCESS = 'FETCH_BRANDS_SUCCESS'
export const FETCH_BRANDS_FAILURE = 'FETCH_BRANDS_FAILURE'
export const FETCH_BRANDS_PROGRESS = 'FETCH_BRANDS_PROGRESS'

export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'
export const FETCH_USERS_PROGRESS = 'FETCH_USERS_PROGRESS'
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE'

export const SET_SELECTED_USER = 'SET_SELECTED_USER'

export const SET_QUOTE_TYPE = 'SET_QUOTE_TYPE'
export const UPDATE_SPO = 'UPDATE_SPO'

export const ADD_NEW_SPO_ITEM = 'ADD_NEW_SPO_ITEM'
export const UPDATE_SPO_ITEM = 'UPDATE_SPO_ITEM'
export const DELETE_SPO_ITEM = 'DELETE_SPO_ITEM'

export const createNewSpo = (user) => ({
	type: CREATE_NEW_SPO,
	user,
})

export const createNewSpoFromData = (data) => ({
	type: CREATE_SPO_FROM_DATA,
	payload: data,
})

export const clearSpoState = () => ({ type: CLEAR_SPO_STATE })

export const fetchCategories =
	(commodityFilter = null, page = 0) =>
	(dispatch) => {
		dispatch({ type: FETCH_CATEGORIES_PROGRESS })
		return API.get(getUrl.getCategories, { page, size: 1000, commodityFilter })
			.then((response) => {
				dispatch({ type: FETCH_CATEGORIES_SUCCESS, payload: convertPagableData(response?.data) })
			})
			.catch((err) => {
				dispatch({ type: FETCH_CATEGORIES_FAILURE, error: err })
			})
	}

export const fetchBrands = (commodityFilter = null) => (dispatch) => {
	dispatch({ type: FETCH_BRANDS_PROGRESS })
	return getAllBrandApi(0, 1000, { commodityFilter })
		.then((response) => {
			dispatch({
				type: FETCH_BRANDS_SUCCESS,
				payload: response?.data?.map((brand) => ({ name: brand.brand_name, id: brand.brand_id })),
			})
		})
		.catch((err) => {
			dispatch({ type: FETCH_BRANDS_FAILURE, error: err })
		})
}

export const fetchAllClients = (globalDispatch, commodityFilter = null) => (dispatch) => {
	dispatch({ type: FETCH_USERS_PROGRESS })
	globalDispatch(showLoader(true))
	return getAllOrgSuppliersApi(commodityFilter)
		.then((response) => {
			dispatch({ type: FETCH_USERS_SUCCESS, payload: response })
			// if (edit) {
			// 	// to find the selected user -> not working now
			// 	const userOrgId = userData?.organisation_id
			// 	let user = response?.data?.find((_u) => _u.organisation_id === userOrgId)
			// 	let _user = {
			// 		...user,
			// 	}
			// 	dispatch({
			// 		type: SET_SELECTED_USER,
			// 		payload: _user,
			// 	})
			// }
		})
		.catch((err) => {
			dispatch({ type: FETCH_USERS_FAILURE, error: err })
		})
		.finally(() => {
			globalDispatch(showLoader(false))
		})
}

export const setSelectedUser = (payload) => ({
	type: SET_SELECTED_USER,
	payload,
})

export const updateSpoQuoteType = (payload) => ({
	type: SET_QUOTE_TYPE,
	payload,
})

export const updateNewSpo = (payload) => ({
	type: UPDATE_SPO,
	payload,
})

export const addOrderItemToSpo = (payload) => ({
	type: ADD_NEW_SPO_ITEM,
	payload,
})

export const updateSpoItem = (payload) => ({
	type: UPDATE_SPO_ITEM,
	payload,
})

export const deleteSpoItem = (payload) => ({
	type: DELETE_SPO_ITEM,
	payload,
})

export const createSpo = (supplierOrder, globalDispatch, navigate) => (dispatch) => {
	globalDispatch(showLoader(true))
	let _supplierOrder = { ...supplierOrder.toJS(), supplier_po_status: poStatus.active }
	createSupplierOrder(_supplierOrder)
		.then((response) => {
			globalDispatch(showToast(true, 'SPO created successfully', { type: TOAST_TYPE.SUCCESS }))
			// On success, go back to the Manage SPO list.
			navigate(paths.admin_manage_spo_status('all'))
		})
		.catch(() => {
			globalDispatch(showToast(true, 'Some error occurred', { type: TOAST_TYPE.ERROR }))
		})
		.finally(() => {
			globalDispatch(showLoader(false))
		})
}

export const updateSpo = (supplierOrder, globalDispatch, update, navigate) => (dispatch) => {
	globalDispatch(showLoader(true))
	updateSpoApi(supplierOrder.toJS())
		.then((response) => {
			globalDispatch(showToast(true, 'SPO updated successfully', { type: TOAST_TYPE.SUCCESS }))
			// On success, go back to the Manage SPO list.
			if (navigate) navigate(paths.admin_manage_spo_status('all'))
			else update?.()
		})
		.catch((error) => {
			globalDispatch(showToast(true, 'SPO not updated !', { type: TOAST_TYPE.ERROR }))
		})
		.finally(() => {
			globalDispatch(showLoader(false))
		})
}
